import { useForm } from '@/Contexts';
import { Path } from 'use-inertia-form/dist/src/utils';

export const useFormInput = <T>(name: string) => {
    const form = useForm();

    if (!form) {
        throw new Error('useFormInput must be used within a FormProvider');
    }

    return {
        value: form.getData(name) as T | undefined,
        setValue: (value: T) => form.setData(name, value),
        error: form.getError(name)
    };
};

export const useDynamicInputs = <TForm, TData extends Record<string, unknown>>(name: Path<TForm>, empty: TData) => {
    const form = useForm();

    if (!form) {
        throw new Error('useDynamicInput must be used within a FormProvider');
    }

    const addValue = () => {
        const currentValue = form.getData(name) as TData[] | undefined;
        const newValue = [...(currentValue ?? []), empty];
        form.setData(name, newValue);
    };

    const removeValue = (index: number) => {
        const currentValue = form.getData(name) as TData[] | undefined;
        const newValue = currentValue?.filter((_, i) => i !== index);
        form.setData(name, newValue);
    };

    return {
        addValue,
        removeValue,
        values: form.getData(name) as TData[] | undefined,
    };
};
